import React from "react";
import styled from "styled-components";

const LoadingWrapper = styled.div`
  background-color: white;
`;
export const LoadingPage = () => {
  return <LoadingWrapper></LoadingWrapper>;
};
